import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

import _ from "lodash";

const initialState = {
    skuif: false,
    take_cards: {
        loading: true,
        success: false,
        error: false,
        errordata: null,
        data: {},
        initialData: {}
    },
    taak_verander_status: {
        error: false,
        errordata: null,
    },
    taak_verander_index: {
        error: false,
        errordata: null,
    },
    take_filter: {},
    skep_instruksie_open: false,
    skep_instruksie_data: {},
    take: {
        agterstand: {
            loading: true,
            success: false,
            error: false,
            errordata: null,
            data: [],
            initialData: []
        },
        besig: {
            loading: true,
            success: false,
            error: false,
            errordata: null,
            data: [],
            initialData: []
        },
        klaar: {
            loading: true,
            success: false,
            error: false,
            errordata: null,
            data: [],
            initialData: []
        },
        onvoltooid: {
            loading: true,
            success: false,
            error: false,
            errordata: null,
            data: [],
            initialData: []
        },
    }
};

const setTakeCards = (state, action) => {
    return updateObject(state, {
        take_cards: {
            ...state.take_cards,
            loading: false,
            success: true,
            error: false,
            errordata: null,
            data: action.cards,
            initialData: action.cards
        }
    });
};

const getTakeCardsFailed = (state, action) => {
    return updateObject(state, {
        take_cards: {
            ...state.take_cards,
            loading: false,
            success: false,
            error: true,
            errordata: {
                easymessage: action.easymessage,
                status: action.status,
                message: action.message
            },
            data: []
        }
    });
};

const setTaakStatusFailed = (state, action) => {
    return updateObject(state, {
        taak_verander_status: {
            ...state.taak_verander_status,
            error: true,
            errordata: {
                easymessage: action.easymessage,
                status: action.status,
                message: action.message
            },
        }
    });
};

const setClearTaakStatusFailed = (state, action) => {
    return updateObject(state, {
        taak_verander_status: {
            ...state.taak_verander_status,
            error: false,
            errordata: null,
        }
    });
};

const setTaakIndexFailed = (state, action) => {
    return updateObject(state, {
        taak_verander_index: {
            ...state.taak_verander_index,
            error: true,
            errordata: {
                easymessage: action.easymessage,
                status: action.status,
                message: action.message
            },
        }
    });
};

const setClearTaakIndexFailed = (state, action) => {
    return updateObject(state, {
        taak_verander_index: {
            ...state.taak_verander_index,
            error: false,
            errordata: null,
        }
    });
};

const applyFilter = (filter, data) => {
    let filtered = data.filter((itemvalue) => {
        var returnvalue = false;
        var kan = true;
        for (const [key, value] of Object.entries(filter)) {
            let nuweid = itemvalue[key].id;
            if (key === "aktiwiteit") {
                nuweid = itemvalue[key].id.substring(1, itemvalue[key].id.indexOf("_") - 1);
            }
            if (key === "toegekenaan") {
                nuweid = itemvalue[key].nuutstearbeidernr;
            }
            if (nuweid && value.indexOf(nuweid.toString()) === -1) {
                kan = false;
            }
        }
        if (kan) {
            returnvalue = itemvalue;
        }
        return returnvalue;
    });
    return filtered;
};

const setTakeFilter = (state, action) => {
    let ids = action.ids;
    if (action.tipe === "aktiwiteit") {
        ids = action.ids.map(item => item.substring(1, item.indexOf("_") - 1));
        ids = [...new Set(ids)];
    }
    var filters = {...state.take_filter, [action.tipe]: ids };

    let take = {};
    for (const [key, value] of Object.entries(state.take)) {
        let data = value.data;
        let filtered = data.filter((itemvalue) => {
            var returnvalue = false;
            var kan = true;
            for (const [key, value] of Object.entries(filters)) {
                let nuweid = itemvalue[key].id;
                if (key === "aktiwiteit") {
                    nuweid = itemvalue[key].id.substring(1, itemvalue[key].id.indexOf("_") - 1);
                }
                if (key === "toegekenaan") {
                    nuweid = itemvalue[key].nuutstearbeidernr;
                }
                if (nuweid && value.indexOf(nuweid.toString()) === -1) {
                    kan = false;
                }
            }
            if (kan) {
                returnvalue = itemvalue;
            }
            return returnvalue;
        });

        take[key] = {
            ...value,
            data: filtered
        };
    }

    return updateObject(state, {
        take: take,
        take_filter: {
            ...state.take_filter,
            [action.tipe]: action.ids
        }
    });
};

const clearTakeFilter = (state, action) => {
    let oldCards = {};
    for (const [key, value] of Object.entries(state.take)) {
        oldCards[key] = {
            ...value,
            data: value.initialData
        };
    }
    return updateObject(state, {
        take: oldCards,
        take_filter: {}
    });
};

const openSkepInstruksie = (state, action) => {
    var data = {};
    if (!action.open) {
        data = {};
    } else {
        data = action.data;
    }
    return updateObject(state, {
        skep_instruksie_data: data,
        skep_instruksie_open: action.open
    });
};

const setTakeCardsSkuif = (state, action) => {
    return updateObject(state, {
        skuif: action.value
    });
};

const setTakeCardsPerLaneLoading = (state, action) => {
    return updateObject(state, {
        take: {
            ...state.take,
            [action.lane]: {
                ...state.take[action.lane],
                loading: true,
                success: false,
                error: false,
                errordata: null
            }
        }
    });
};

const setTakeCardsPerLane = (state, action) => {
    let lastindex = null;
    let lastid = null;
    if (action.cards.length > 0) {
        lastindex = action.cards.map(item => item.indx);
        lastindex = _.max(lastindex);
        lastid = action.cards.filter(item => item.indx === lastindex)[0].id;
    }
    let newCards = applyFilter(state.take_filter, action.cards);
    newCards = _.sortBy(newCards, ["indx", "id"]);
    return updateObject(state, {
        skuif: false,
        take: {
            ...state.take,
            [action.lane]: {
                lazyloading: false,
                loading: false,
                success: true,
                error: false,
                errordata: null,
                lastindex: lastindex,
                lastid: lastid,
                itemcount: action.cards.length,
                data: newCards,
                initialData: newCards
            }
        }
    });
};

const getTakeCardsPerLaneFailed = (state, action) => {
    return updateObject(state, {
        take: {
            ...state.take,
            [action.lane]: {
                ...state.take[action.lane],
                loading: false,
                success: false,
                error: true,
                errordata: {
                    easymessage: action.easymessage,
                    status: action.status,
                    message: action.message
                },
                data: []
            }
        }
    });
};

const setTakeCardsPerLaneLazyLoading = (state, action) => {
    return updateObject(state, {
        take: {
            ...state.take,
            [action.lane]: {
                ...state.take[action.lane],
                lazyloading: true
            }
        }
    });
};

const setTakeCardsPerLaneLazy = (state, action) => {
    let lastindex = null;
    let lastid = null;
    if (action.cards.length > 0) {
        lastindex = action.cards.map(item => item.indx);
        lastindex = _.max(lastindex);
        lastid = action.cards.filter(item => item.indx === lastindex)[0].id;
    }
    let cards = _.uniqBy([...action.cards, ...(state.take[action.lane].data || [])], "id");
    let newCards = Object.values(state.take_filter).length > 0 ? applyFilter(state.take_filter, cards) : cards;
    newCards = _.sortBy(newCards, ["indx", "id"]);
    return updateObject(state, {
        skuif: false,
        take: {
            ...state.take,
            [action.lane]: {
                lazyloading: false,
                loading: false,
                success: true,
                error: false,
                errordata: null,
                lastindex: lastindex,
                lastid: lastid,
                itemcount: newCards.length,
                data: newCards,
                initialData: newCards
            }
        }
    });
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_TAKE_CARDS:
            return setTakeCards(state, action);
        case actionTypes.GET_TAKE_CARDS_FAILED:
            return getTakeCardsFailed(state, action);
        case actionTypes.SET_TAAK_STATUS_FAILED:
            return setTaakStatusFailed(state, action);
        case actionTypes.CLEAR_TAAK_STATUS_FAILED:
            return setClearTaakStatusFailed(state, action);
        case actionTypes.SET_TAKE_FILTER:
            return setTakeFilter(state, action);
        case actionTypes.CLEAR_TAKE_FILTER:
            return clearTakeFilter(state, action);
        case actionTypes.SET_TAAK_INDEX_FAILED:
            return setTaakIndexFailed(state, action);
        case actionTypes.CLEAR_TAAK_INDEX_FAILED:
            return setClearTaakIndexFailed(state, action);
        case actionTypes.OPEN_SKEP_INSTRUKSIE:
            return openSkepInstruksie(state, action);
        case actionTypes.SET_TAKE_CARDS_PER_LANE_LOADING:
            return setTakeCardsPerLaneLoading(state, action);
        case actionTypes.SET_TAKE_CARDS_PER_LANE:
            return setTakeCardsPerLane(state, action);
        case actionTypes.GET_TAKE_CARDS_PER_LANE_FAILED:
            return getTakeCardsPerLaneFailed(state, action);
        case actionTypes.SET_TAKE_CARDS_PER_LANE_LAZY_LOADING:
            return setTakeCardsPerLaneLazyLoading(state, action);
        case actionTypes.SET_TAKE_CARDS_PER_LANE_LAZY:
            return setTakeCardsPerLaneLazy(state, action);
        case actionTypes.SET_TAKE_CARDS_SKUIF:
            return setTakeCardsSkuif(state, action);
        default:
            return state;
    }
};

export default reducer;